import { render } from "./MediaChangedProperties.vue?vue&type=template&id=8d868a32"
import script from "./MediaChangedProperties.vue?vue&type=script&lang=js"
export * from "./MediaChangedProperties.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__